import type { UseFormRegisterReturn } from 'react-hook-form';
import { ASSIGNABLE_ROLES, ROLE_NAMES } from '../constants/roles';

interface RolePickerProps {
  id: string;
  registration: UseFormRegisterReturn;
}

export default function RolePicker({ id, registration }: RolePickerProps) {
  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1 block text-sm font-medium text-gray-700"
      >
        Role
      </label>
      <select
        id={id}
        {...registration}
        className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        {ASSIGNABLE_ROLES.map((role) => (
          <option key={role} value={role}>
            {ROLE_NAMES[role]}
          </option>
        ))}
      </select>
    </div>
  );
}
